
import './App.css';
import MainLayout from './features/layouts/MainLayout';
import withAuth from './auth/authwrapper';
import 'react-toastify/dist/ReactToastify.css';
import { Bounce, ToastContainer } from 'react-toastify';
import AutoLogout from './auth/autoLogout';


function App() {
  return (
    <>
      <AutoLogout />
      <div className="container-scroller">
        <MainLayout />
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
    </>
  );
}

export default withAuth()(App);
//export default App;
